// custom.js
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('.card').forEach(card => {
    // バッジ（.badge）のテキストが "Sold out" なら
    const badge = card.querySelector('.badge');
    if (badge && badge.textContent.trim().toLowerCase() === 'sold out') {
      card.classList.add('is-sold-out');
    }
  });
});
